export default 'https://tme.understood.org/assets/dog.9460ba6f.lottie'